/**
 * Matrix lamp for Olsztyn
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'
import Konva from 'konva'

export default class Mps extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'mps',
        x: 0,
        y: 0,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: 'white',
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 15,
        radius: 15,
        fill: 'white'
      }),

      new Ren.Line({
        points: [15, 30, 15, 50],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 50, 30, 50],
        strokeWidth: 2,
        opacity: 0.8
      }),

      // display of signals
      // GO STRAIGHT: |
      // GO LEFT: \
      // GO RIGHT: /
      // STOP: --

      // signals
      new Konva.Text({
        name: 'matrixLampValue',
        x: 10,
        y: 15,
        text: 'N/A',
        fontSize: 13,
        fill: 'black'
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    if (status.lampValues) {
      this.modifyShape('matrixLampValue', 'text', status.lampValues[0][1])
    }
  }
}
